<app-main-wrapper title="My Opportunities">
  <div class="wrapper">
    <table class="opp-table">
      <thead>
        <tr>
          <th
            class="col-name sortable"
            [class.active]="sortField === 'opportunity_name'"
            (click)="sortBy('opportunity_name')"
          >
            Name
            <i
              *ngIf="sortField === 'opportunity_name'"
              class="fa-solid sort-icon"
              [ngClass]="sortDirection === 'asc' ? 'fa-arrow-up' : 'fa-arrow-down'"
            ></i>
          </th>
          <th
            class="col-date sortable"
            [class.active]="sortField === 'updated_at'"
            (click)="sortBy('updated_at')"
          >
            Updated
            <i
              *ngIf="sortField === 'updated_at'"
              class="fa-solid sort-icon"
              [ngClass]="sortDirection === 'asc' ? 'fa-arrow-up' : 'fa-arrow-down'"
            ></i>
          </th>
          <th class="col-action"></th>
        </tr>
      </thead>
      <tbody>
        @for (oppportunityDetail of sortedOpportunities; track
        oppportunityDetail.id) {
        <tr
          class="opp-row"
          (click)="openDeatilPage(oppportunityDetail)"
        >
          <td class="opp-name"> {{ oppportunityDetail.opportunity_name }}</td>
          <td class="opp-date">{{ oppportunityDetail.updated_at | date : "d MMM, y" }}</td>
          <td class="opp-action-cell">
            <span class="opp-action">
              <span class="opp-action__label">View</span>
              <i class="fa-solid fa-chevron-right opp-action__icon"></i>
            </span>
          </td>
        </tr>
        }
      </tbody>
    </table>
  </div>
</app-main-wrapper>
